/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Gpestimatedticketsize_Modal_Mingreaterthanzero7Inputs */

const en_coinvestments_gpestimatedticketsize_modal_mingreaterthanzero7 = /** @type {(inputs: Coinvestments_Gpestimatedticketsize_Modal_Mingreaterthanzero7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum ticket size must be greater than zero`)
};

/**
* | output |
* | --- |
* | "Minimum ticket size must be greater than zero" |
*
* @param {Coinvestments_Gpestimatedticketsize_Modal_Mingreaterthanzero7Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_gpestimatedticketsize_modal_mingreaterthanzero7 = /** @type {((inputs?: Coinvestments_Gpestimatedticketsize_Modal_Mingreaterthanzero7Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Gpestimatedticketsize_Modal_Mingreaterthanzero7Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_gpestimatedticketsize_modal_mingreaterthanzero7(inputs)
});
export { coinvestments_gpestimatedticketsize_modal_mingreaterthanzero7 as "coInvestments_gpEstimatedTicketSize_modal_minGreaterThanZero" }